import React from 'react';
import {downloadFile} from '../helper';
import Nbsp from '../components/Nbsp';
import FileExist from '../components/FileExist';

class File extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let id = this.props.id;
        let onclick = function() {downloadFile(id)};
        return (
            <span>
                <a onClick={onclick} target="_blank" className="psevdo_href" rel="noopener">
                    {this.props.title}
                </a>
                <Nbsp/>
                <FileExist fileExist={this.props.fileExist}/>
            </span>
        )
    }
}
export default File;